<div class="new-login-ui fresh-ui">
    <div class="modal-header">
        <div class="font-600 fs-pv-title general_sans">
            {{videoData?.DescEnglish}}
        </div>
        <span class="material-icons pr-2 d-flex cursor-pointer cursor-pointer"
            (click)="closeVideoPreview()">
            cancel
        </span>
    </div>
    <div class="modal-body p-0">
        <div class="embed-video">
            <!-- <iframe width="100%" height="100%" frameborder="0" class="iframe"
                [src]="safeVideoValue"
                webkitallowfullscreen mozallowfullscreen allowfullscreen
                playsinline loop
                loading="lazy" allowfullscreen></iframe> -->

            <iframe class="pv-iframe"
            [ngClass]="videoData?.DisplayType === 1 ? 'pv-iframe' : 'pv-iframe-mobile'"
                [src]="safeVideoValue"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen></iframe>
        </div>
    </div>
    <div class="modal-footer py-1 d-flex justify-content-between">
        <div class="row d-none d-md-flex">
            <div class="col-md col-12">
                <div class="general_sans text-center text-md-left" style="font-weight: bold;">
                    Do you liked it? Go and create your own personlise card and video.
                </div>
            </div>
        </div>
        <div class="col-md-auto col-12">
            <a
                ngbTooltip="Customize video and card by yourself and preview instantly!"
                class="btn-247 btn-primary-preview btn-large btn-medium-radius cursor-pointer w-100 d-block"
                (click)="startEditing()">Start
                Editing
            </a>
        </div>
    </div>
</div>